import api, { handleResponse, handleError } from './api';

/**
 * Party Engine — AI-seeded Party Starters that real hosts claim.
 *
 * Two surfaces share this module: the admin control plane under /admin/party-engine
 * (runs, review, publish, revoke) and the host-facing claim endpoints under /party-engine
 * (what's looking for a host, claim one).
 */
const wrap = async (call) => {
  try {
    return handleResponse(await call());
  } catch (error) {
    return handleError(error);
  }
};

const partyEngineService = {
  // ── Admin ──────────────────────────────────────────────────────────────
  getHealth: () => wrap(() => api.get('/admin/party-engine/health')),
  searchRegions: (q) => wrap(() => api.get('/admin/party-engine/regions/search', { params: { q } })),
  startRun: (regionId, payload) => wrap(() => api.post(`/admin/party-engine/regions/${regionId}/runs`, payload)),
  listRuns: (params = {}) => wrap(() => api.get('/admin/party-engine/runs', { params })),
  getRun: (runId) => wrap(() => api.get(`/admin/party-engine/runs/${runId}`)),
  cancelRun: (runId) => wrap(() => api.post(`/admin/party-engine/runs/${runId}/cancel`)),
  publishApproved: (runId) => wrap(() => api.post(`/admin/party-engine/runs/${runId}/publish-approved`)),
  resendInvites: (runId) => wrap(() => api.post(`/admin/party-engine/runs/${runId}/resend-invites`)),
  previewConcept: (conceptId) => wrap(() => api.get(`/admin/party-engine/concepts/${conceptId}/preview`)),
  updateConcept: (conceptId, payload) => wrap(() => api.put(`/admin/party-engine/concepts/${conceptId}`, payload)),
  conceptAction: (conceptId, action) => wrap(() => api.post(`/admin/party-engine/concepts/${conceptId}/${action}`)),
  revokeClaim: (eventId) => wrap(() => api.post(`/admin/party-engine/events/${eventId}/revoke-claim`)),

  // ── Host ───────────────────────────────────────────────────────────────
  getClaimable: (params = {}) => wrap(() => api.get('/party-engine/claimable', { params })),
  getClaimableRegions: () => wrap(() => api.get('/party-engine/claimable/regions')),
  getClaimInfo: (eventId) => wrap(() => api.get(`/party-engine/events/${eventId}/claim-info`)),
  claim: (eventId) => wrap(() => api.post(`/party-engine/events/${eventId}/claim`)),
};

export default partyEngineService;
